module.exports = __webpack_public_path__ + "static/media/mask.072b0975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/mask.jpg
// module id = 1187
// module chunks = 110